export default {
  projectDesc: 'A <strong>Vue2</strong> plugin to make files upload easier, single file upload with image preview, multiple upload with drag and drop.',
  useDialog: 'There is using <a href="https://github.com/TerryZ/v-dialogs" target="_blank">v-dialogs</a> to show message in example',
  demo: {
    title: 'the example will always return same image',
    single: 'single file mode',
    multiple: 'multiple file mode',
    multipleSub: 'set option "multiple" to <code>true</code>',
    customSize: 'Single file upload, customize preview container size',
    noPreview: 'Single file upload, no preview and button only, suitable for upload not image type file',
    uploadedInfo: 'Uploaded file info',
    buttonText: 'Single file upload, customize button text',
    noIcon: 'Single file upload, no button icon',
    customPreviewImage: 'Single file upload, customize preview container default image'
  },
  option: {
    multiple: 'the file upload mode; in multiple upload mode, support drag files to upload',
    language: 'v-uploader support i18n and provide 2 language so far',
    fileSizeLimit: 'upload file size limit',
    fileTypeExts: 'set upload file extension restriction',
    imageMaxHeight: 'set image max height(pixel), set 0 to unlimited',
    imageMaxWidth: 'set image max width(pixel), set 0 to unlimited',
    imageMinHeight: 'set image min height(pixel), set 0 to unlimited',
    imageMinWidth: 'set image min width(pixel), set 0 to unlimited',
    uploadFileUrl: 'file upload service url',
    deleteFileUrl: 'file delete service url',
    showMessage: 'set the way to show upload message(upload fail message)',
    preview: 'the container to preview uploaded image',
    previewImg: 'the image show in preview container by default',
    previewWidth: 'preview container width (px)',
    previewHeight: 'preview container height (px)',
    buttonText: 'text in the upload button',
    buttonIcon: 'show "open folder" icon in upload button',
    uploadFileObjName: 'the name to receive file stream',
    itemLimit: 'limit the number of upload files, set 0 to unlimited and work on multiple mode',
    beforeUpload: 'the function to do customize check before file upload, when return false, plugin will not to upload current file(s)<br>' +
              '<strong>parameters</strong>:<br>' +
              'id[number] - The current file\'s id<br>' +
              'name[string] - The current file\' name'
  },
  event: {
    done: 'return files info when uploaded success',
    doneArgs: 'uploaded files info'
  },
  server: {
    title: 'Server side',
    request: {
      title: 'request',
      uploadFileObj: 'the name to receive file stream',
      fileSizeLimit: 'the setting of file size limit',
      fileTypeExts: 'the setting of file extensions'
    },
    response: {
      title: 'response',
      desc: 'file upload and delete file just need return same format result(json)',
      success: 'file upload state',
      error: 'the reason of file upload fail\t',
      url: 'full path of image',
      example: 'response example'
    }
  }
}
